import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class MealService {
  private readonly apiService = inject(ApiService);

  /**
   * Fetches the list of users from the API
   * @returns Observable containing the user list
   */
  getMealInfo(payload: any): Observable<any> {
    return this.apiService.post<any>(API_ENDPOINTS.MEAL_INFO.LIST,payload);
  }

  updateMealInfo(payload: any): Observable<any> {
    return this.apiService.post<any>(API_ENDPOINTS.MEAL_INFO.UPDATE,payload);
  }
}

